<template>
  <default-layout>
    <template slot="title">
      Sign In
    </template>
    <template slot="contents">
      <div class="columns is-centered">
        <vs-loader :visible="isLoading" />
        <div
          v-if="!isLoading"
          class="column is-one-third"
        >
          <form @submit.prevent="signInAndMoveToDashboard">
            <input
              v-model="email"
              class="input"
              type="email"
              placeholder="Email"
              required
            >
            <input
              v-model="password"
              class="input"
              type="password"
              placeholder="Password"
              required
            >
            <p
              v-if="errorStatus"
              class="help is-danger"
            >
              This email or the password is invalid
            </p>
            <button
              type="submit"
              class="button is-primary"
            >
              Sign in
            </button>
          </form>
          <footer>
            <span>If you forgot your password,</span>
            <br>
            <span>please email us at </span><a href="mailto:japan@virtusize.com">japan@virtusize.com</a>
          </footer>
        </div>
      </div>
    </template>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/Default'
import { mapActions } from 'vuex'

export default {
  components: {
    DefaultLayout
  },
  data () {
    return {
      email: '',
      password: '',
      errorStatus: false,
      isLoading: false
    }
  },
  methods: {
    ...mapActions('user', [
      'signIn'
    ]),
    async signInAndMoveToDashboard () {
      this.isLoading = true
      this.errorStatus = false
      try {
        await this.signIn({
          email: this.email,
          password: this.password
        })
        this.$router.push({ name: 'dashboard' })
      } catch (e) {
        this.errorStatus = true
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.input {
  height: 50px;
  margin-bottom: 20px;
}

.button {
  width: 120px;
  height: 50px;
  margin-top: 10px;
}

.help {
  text-align: left;
}

footer {
  margin-top: 100px;
  font-size: 13px;
}
</style>
